import { useAppStore } from '@/stores/appStore';
import { Check, Loader2, CloudOff, AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function SyncIndicator() {
  const { syncStatus, isOffline } = useAppStore();

  if (syncStatus === 'synced' && !isOffline) return null;

  const config = {
    synced: { icon: Check, text: 'Synced', color: 'text-green-500' },
    syncing: { icon: Loader2, text: 'Syncing...', color: 'text-blue-500' },
    pending: { icon: CloudOff, text: 'Pending sync', color: 'text-yellow-500' },
    error: { icon: AlertCircle, text: 'Sync error', color: 'text-red-500' },
  };

  const { icon: Icon, text, color } = config[syncStatus];

  return (
    <div className={cn(
      'fixed top-20 right-4 z-50',
      'bg-background border rounded-lg px-3 py-2 shadow-lg',
      'flex items-center gap-2 text-sm'
    )}>
      <Icon className={cn('w-4 h-4', color, syncStatus === 'syncing' && 'animate-spin')} />
      <span className={color}>{text}</span>
    </div>
  );
}
